
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`ይህ በ
                    <a href="${0}">Folksonomy Engine ፕሮጀክት</a>ነው ያመጣው።
                    ለመሳተፍ ወይም አስተያየት ለመስጠት አያቅማሙ`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`ይህ መሳሪያ የእቃዎቹን ዝርዝር ለማረም ያስችልዎታል.
                ንጥረ ነገሮች ዝርዝር ማከል፣ ማስወገድ ወይም ማርትዕ ይችላሉ።
                <br>
                ይህ ገፀ ባህሪ <span class="highlight">␣</span> ቦታን ይወክላል።
                <br>
                ይህ ገፀ ባህሪ <span class="highlight">↩︎</span> የመስመር መቋረጥን ይወክላል። `,
'hb28f1f2ec1744ee9': html`እነዚህ ንብረቶች ለማንኛውም አይነት አጠቃቀም በተጠቃሚዎች የተፈጠሩ እና የተመዘገቡ ናቸው። የእራስዎን ለመጨመር
                    ነፃነት ይሰማዎ።
                    <strong>የሚፈጥሯቸው ንብረቶች እና እሴቶች ተጨባጭ</strong>መሆን አለባቸው። ወደ
                    <a href="${0}">ማህበረሰቡ የሚጠቀምባቸውን ንብረቶች ዝርዝር</a>
                    መዝለል ወይም
                    <a href="${1}">ንብረቶችን ሰነዶች እና የፍለጋ ሞተሩ</a>ማሰስ ይችላሉ።`,
's000a5b76bd3a01c2': `ንብረቶችን በመጫን ላይ...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `ለዕቃዎች እርዳን`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `ሰብልን ያረጋግጡ`,
's03e9c8114521b998': `ንጥረ ነገሮቹን አርትዕ አደርጋለሁ`,
's05ec315d9308091a': `የባርኮድ ማዕዘኖች አዶ`,
's061eb5af92512c85': `ተቀምጧል! በሌላ መርዳት ትችላለህ?`,
's06847c221c4c0bc1': `[የአጠቃቀም ጉዳይዎን ለመግለፅ] ንብረት መፍጠር እፈልጋለሁ...`,
's06f6c6f99db6b552': `ኦሪጅናል`,
's081e2ad82db71e1d': `የተሰባሰቡ እሴቶች`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `የወሰኑ ሰነዶች`,
's0bb2d48532acc455': `CSV አውርድ`,
's0d5b7fee0311db68': `ንብረት`,
's0fb218abc2e157ed': `ምስል የተሳሳተ ነው።`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `ሰብል ሰርዝ`,
's11a18a69b30b65ed': `በንጥረ ነገሮች ዝርዝር ውስጥ ያሉ ስህተቶችን እንድናስተካክል እርዳን`,
's1205d5f6fccf8e69': `የንብረት ዋጋ`,
's15d64a0a6715285a': `አዲስ ቁልፍ`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `ምርጫ አካባቢ`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `የአመጋገብ መረጃውን ለማስተካከል እርዳን`,
's1e00019dc454872d': `እባክዎ የንብረት ስም ባህሪን በመጠቀም የንብረት ስም ያቅርቡ።`,
's1e49126af0935a5b': `ይህንን ንብረት የሚጠቀሙ ምርቶች ዝርዝር`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `ንብረቱን ይመዝግቡ`,
's300b3a6ee4e1252d': str`ደካማ ግጥሚያ ${0}%`,
's33f786bb6b4f0cf4': `የሰብል ውጤት`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `መጀመሪያ ማህበረሰቡን ይጠይቁ`,
's36d86adc823cbfa6': `አዲስ ንብረት ከመፍጠርዎ በፊት ከማህበረሰቡ ጋር ይወያዩ፡-`,
's3781d25aa51a736c': `የፎልክሶኖሚ ሞተር ሰነድ`,
's383ae4449428b61e': `ሰብልን ዳግም አስጀምር`,
's39bcf88721a1e8ee': `ምርጫን ዳግም አስጀምር`,
's39e14e14300694c7': `ሰነዶች እና መመሪያዎች`,
's3b430cfa5c1fe7f4': str`ሰነዶች ለ ${0}`,
's3f4e4b52f230a892': `የምስል ሸራ`,
's417b90913e05bc17': `ቅድመ እይታ`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `የመሃል ምስል`,
's42dd66b2441566fd': `ማእከል ኣይኮነን`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `ንጥረ ነገር ይጨምሩ`,
's453ab0dbb9b5c777': `ልክ ቀይር`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `የምርት ብዛት`,
's4df2f533c0c1e7d0': `የምስል መቆጣጠሪያዎች`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `ምርጫን አንቀሳቅስ`,
's4f751fb9b3ed766c': `አዲስ ንብረት መፍጠር`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `የንብረት ስም አስገባ...`,
's55d7249883a98ca1': `ስለዚህ ንብረት በ Open Food Facts wiki ላይ`,
's565867d84c04aea2': `የማጣሪያ ባህሪያት...`,
's5666afe5cd0166de': `እባክዎን ከማረጋገጥዎ በፊት ስህተቶቹን ያስተካክሉ ወይም ጽሑፉን ያሻሽሉ።`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `ምርቶችን በመጫን ላይ...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `የአመጋገብ መረጃውን ለማስተካከል እርዳን።`,
's5dd6f12783fca34f': `ንጥረ ነገሮች ዝርዝር አርትዕ`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `ላበረከቱት አስተዋጽኦ እናመሰግናለን!`,
's6cee7cad81dfedd1': `የተከረከመ ምስል`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`ጥሩ ግጥሚያ ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `ሰነድ`,
's787dd11bed0dc88a': `ወደ ግራ መጠን ቀይር`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `ስለ ንብረት አፈጣጠር እና መመሪያዎች የበለጠ ይረዱ፡`,
's8038273de2cf8b73': `እባክዎ ለመከርከም ክልል ይምረጡ።`,
's839cc2908a5387f2': `የአሞሌ ኮድ አጣራ...`,
's86197dcf3e96af64': `ያሉትን ንብረቶች ያስሱ እና ይፈልጉ`,
's8a63be30a129a59c': `የታችኛውን መጠን ቀይር`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `ከላይ ወደ ቀኝ ቀይር`,
's8db84aa4bc949af2': `አዲሱን ንብረት ይመዝግቡ`,
's8f839a03997a16d7': `ምርትን ይመልከቱ`,
's901ae1e236ac45d3': `ስረዛን ሰርዝ`,
's907f7a97c6b29425': `የመረጃው ሞዴል ሊሻሻል እንደሚችል ልብ ይበሉ። በራስዎ ሃላፊነት ይጠቀሙ።`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `ንጥረ ነገሮች:`,
's9a7f60fce090ecaf': `ንብረቶችን መጫን አልተሳካም። እባክዎ ቆይተው እንደገና ይሞክሩ።`,
's9b87abd68fb9df45': `አልተገኘም? አዲስ ቁልፍ {value}ይፍጠሩ`,
's9c0f52425fd2f07e': `አይዛመድም።`,
's9fc41f789c63b40d': `ምርቶች`,
'sa1fa766e0d5634d7': `ምንም ነጥብ አይገኝም`,
'sa548778b24054030': `ከፎልክሶኖሚ ሞተር ፕሮጀክት ሁሉንም የተሰጡ ንብረቶችን ያስሱ። እነዚህ ንብረቶች በክፍት የምግብ እውነታዎች ዳታቤዝ ውስጥ ስለ ምርቶች ተጨማሪ ሜታዳታ እና ግንዛቤዎችን ይሰጣሉ።`,
'sa63907958bd0ec4b': `ከላይ በግራ በኩል ቀይር`,
'sa95b4224f685a36a': `ሞዳል ዝጋ`,
'sab56a1d439576fd6': `የጥቆማ አዶ`,
'sac47ea2901d04c15': `የታችኛውን ግራ መጠን ቀይር`,
'sb125227d436c2925': `ባለው የንብረት ዳታቤዝ ውስጥ የንብረትዎን ጽንሰ-ሀሳብ ይፈልጉ፡-`,
'sb125568d43642e6f': `ስለ ምርቱ ጥያቄዎችን ይመልሱ.`,
'sb1c538e038f9b214': str`በጣም ጥሩ ግጥሚያ ${0}%`,
'sb28639570ff3b852': `የሁሉም ንብረቶች ዝርዝር`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `አንዴ ንብረትዎ አለመኖሩን ካረጋገጡ እና ማህበረሰቡ ጠቃሚ መሆኑን ከተስማማ በመጀመሪያ በዊኪ ውስጥ መመዝገብ ያስፈልግዎታል።`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `ለዚህ ንብረት ምንም ምርቶች አልተገኙም።`,
'sb7f72e4c8a2d3357': `ዋጋዎችን አጣራ...`,
'sb8178320160f84ea': `ሰብል አሳይ`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `ሁሉም ግንዛቤዎች ምላሽ አግኝተዋል! ለእርዳታዎ እናመሰግናለን!`,
'sbd9a0b2293b3cd3c': `የማቅረቢያ መጠን`,
'sbe472dc3c2685985': `ተጓዳኝ እሴት`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `የላይኛውን መጠን ቀይር`,
'sc1c08d0cbcc3bd24': `አይዛመድም።`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `መጠገን ይመከራል`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `ምስል አንቀሳቅስ`,
'sc895972c88d38ca5': `ፎልክሶኖሚ ንብረት`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `ረድፎች`,
'scb3b0671d7b7f640': `አዲስ እሴት`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `የSlack ውይይትን ይቀላቀሉ`,
'scdb6cad0b92721bf': `ምንም ንብረቶች አልተገኙም።`,
'scf23a05631f93732': `መሰረዝን ያረጋግጡ`,
'scfed2f270ef6a3aa': `አካባቢ ይምረጡ`,
'sd1022bc1ef9204f7': `ማጉላት የሚችል ምስል`,
'sd1077c055cf9ba6b': `የምርቱን ንጥረ ነገር ዝርዝር ለማረጋገጥ ያግዙን።`,
'sd698d21ddecba56b': `ሄይ! የሚከተሉትን ክፍሎች በመመለስ የምርት መረጃውን እንድናሻሽል ሊረዱን ይችላሉ።`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `ንብረት አስቀድሞ መኖሩን ያረጋግጡ`,
'sdbf806fefc584115': `ማግኘት አለብህ`,
'sdc673e73b5c13aea': `ሰርዝ`,
'sdc792b75f1edcaba': `የንጥረ ነገሮችን አጻጻፍ ለማረም ያግዙን።`,
'sdca5deead576ceee': `ከታች ወደ ቀኝ ቀይር`,
'sdcc2555c5dde524f': `እርግጠኛ ነዎት ይህን ንጥል መሰረዝ ይፈልጋሉ? ይህ እርምጃ ሊቀለበስ አይችልም።`,
'se206feec7ec57b28': `በ100 ግራም`,
'se419a9ab36987490': `ትክክል ያልሆነ`,
'se5127cf0f92e7e48': `ጠቃሚ ምክር: እንዲሁም ማግኘት ይችላሉ`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `የተሻለ ሰብል ሀሳብ አቀርባለሁ።`,
'seea3800e27baa686': `የግለሰብ ምርቶች`,
'sefaba4adc4ec9219': `Folksonomy Properties`,
'seffa8ca49175b5f0': `ለግል የተበጁ ንብረቶች`,
'sf44a6b3b232c28ea': str`የአሁኑን ዋጋ በ ${0}ይተኩ`,
'sf4cd86a2f5ef2588': `የምርት ባር ኮድ`,
'sf57a61152168cc81': `የንጥረ ነገር ማወቂያውን እንድናስተካክል እርዳን`,
'sf88b90b8ba23871c': `ያልታወቀ ተዛማጅ`,
'sf9aee319a006c9b4': `ያክሉ`,
'sfacbbe968fa7d773': `የንብረት ስም፡-`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `ተጓዳኝ እሴት`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  